import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    const isAdmin = url.startsWith("/admin") && !url.startsWith("/admin/auth/");
    if (error.response?.status === 401 && isAdmin && !cfg._retried) {
      cfg._retried = true;
      try {
        refreshing = refreshing || api.post("/admin/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
        window.dispatchEvent(new Event("admin-logged-out"));
      }
    }
    return Promise.reject(error);
  }
);

export const assetUrl = (path) => (path ? `${BACKEND_URL}${path}` : null);
export const fileUrl = (id, v = "full") => (id ? `${API}/files/${id}?v=${v}` : null);

export function errorCode(e) {
  const detail = e?.response?.data?.detail;
  if (!e?.response) return "network";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return "invalid_choice";
  return "generic";
}

export function errorText(t, e) {
  const code = errorCode(e);
  return t(`errors.${code}`, { defaultValue: t("errors.generic") });
}
